/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as KitchenRouteImport } from './routes/kitchen'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminVouchersRouteImport } from './routes/admin/vouchers'
import { Route as AdminTrialBalanceRouteImport } from './routes/admin/trial-balance'
import { Route as AdminTablesRouteImport } from './routes/admin/tables'
import { Route as AdminStaffRouteImport } from './routes/admin/staff'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminServerRouteImport } from './routes/admin/server'
import { Route as AdminSalesReturnsRouteImport } from './routes/admin/sales-returns'
import { Route as AdminSalesEntryRouteImport } from './routes/admin/sales-entry'
import { Route as AdminReportsRouteImport } from './routes/admin/reports'
import { Route as AdminQuotationsRouteImport } from './routes/admin/quotations'
import { Route as AdminPurchaseReturnsRouteImport } from './routes/admin/purchase-returns'
import { Route as AdminPurchaseInvoicesRouteImport } from './routes/admin/purchase-invoices'
import { Route as AdminMenuRouteImport } from './routes/admin/menu'
import { Route as AdminLedgerRouteImport } from './routes/admin/ledger'
import { Route as AdminKitchenRouteImport } from './routes/admin/kitchen'
import { Route as AdminDaybookRouteImport } from './routes/admin/daybook'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminCounterRouteImport } from './routes/admin/counter'
import { Route as AdminCompanyRouteImport } from './routes/admin/company'
import { Route as AdminAccountsRouteImport } from './routes/admin/accounts'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const KitchenRoute = KitchenRouteImport.update({
  id: '/kitchen',
  path: '/kitchen',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVouchersRoute = AdminVouchersRouteImport.update({
  id: '/vouchers',
  path: '/vouchers',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTrialBalanceRoute = AdminTrialBalanceRouteImport.update({
  id: '/trial-balance',
  path: '/trial-balance',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTablesRoute = AdminTablesRouteImport.update({
  id: '/tables',
  path: '/tables',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStaffRoute = AdminStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminServerRoute = AdminServerRouteImport.update({
  id: '/server',
  path: '/server',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSalesReturnsRoute = AdminSalesReturnsRouteImport.update({
  id: '/sales-returns',
  path: '/sales-returns',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSalesEntryRoute = AdminSalesEntryRouteImport.update({
  id: '/sales-entry',
  path: '/sales-entry',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReportsRoute = AdminReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQuotationsRoute = AdminQuotationsRouteImport.update({
  id: '/quotations',
  path: '/quotations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPurchaseReturnsRoute = AdminPurchaseReturnsRouteImport.update({
  id: '/purchase-returns',
  path: '/purchase-returns',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPurchaseInvoicesRoute = AdminPurchaseInvoicesRouteImport.update({
  id: '/purchase-invoices',
  path: '/purchase-invoices',
  getParentRoute: () => AdminRoute,
} as any)
const AdminMenuRoute = AdminMenuRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => AdminRoute,
} as any)
const AdminLedgerRoute = AdminLedgerRouteImport.update({
  id: '/ledger',
  path: '/ledger',
  getParentRoute: () => AdminRoute,
} as any)
const AdminKitchenRoute = AdminKitchenRouteImport.update({
  id: '/kitchen',
  path: '/kitchen',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDaybookRoute = AdminDaybookRouteImport.update({
  id: '/daybook',
  path: '/daybook',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCounterRoute = AdminCounterRouteImport.update({
  id: '/counter',
  path: '/counter',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCompanyRoute = AdminCompanyRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAccountsRoute = AdminAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AdminRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/kitchen': typeof KitchenRoute
  '/login': typeof LoginRoute
  '/admin/accounts': typeof AdminAccountsRoute
  '/admin/company': typeof AdminCompanyRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/daybook': typeof AdminDaybookRoute
  '/admin/kitchen': typeof AdminKitchenRoute
  '/admin/ledger': typeof AdminLedgerRoute
  '/admin/menu': typeof AdminMenuRoute
  '/admin/purchase-invoices': typeof AdminPurchaseInvoicesRoute
  '/admin/purchase-returns': typeof AdminPurchaseReturnsRoute
  '/admin/quotations': typeof AdminQuotationsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/sales-entry': typeof AdminSalesEntryRoute
  '/admin/sales-returns': typeof AdminSalesReturnsRoute
  '/admin/server': typeof AdminServerRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/tables': typeof AdminTablesRoute
  '/admin/trial-balance': typeof AdminTrialBalanceRoute
  '/admin/vouchers': typeof AdminVouchersRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/kitchen': typeof KitchenRoute
  '/login': typeof LoginRoute
  '/admin/accounts': typeof AdminAccountsRoute
  '/admin/company': typeof AdminCompanyRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/daybook': typeof AdminDaybookRoute
  '/admin/kitchen': typeof AdminKitchenRoute
  '/admin/ledger': typeof AdminLedgerRoute
  '/admin/menu': typeof AdminMenuRoute
  '/admin/purchase-invoices': typeof AdminPurchaseInvoicesRoute
  '/admin/purchase-returns': typeof AdminPurchaseReturnsRoute
  '/admin/quotations': typeof AdminQuotationsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/sales-entry': typeof AdminSalesEntryRoute
  '/admin/sales-returns': typeof AdminSalesReturnsRoute
  '/admin/server': typeof AdminServerRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/tables': typeof AdminTablesRoute
  '/admin/trial-balance': typeof AdminTrialBalanceRoute
  '/admin/vouchers': typeof AdminVouchersRoute
  '/admin': typeof AdminIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/kitchen': typeof KitchenRoute
  '/login': typeof LoginRoute
  '/admin/accounts': typeof AdminAccountsRoute
  '/admin/company': typeof AdminCompanyRoute
  '/admin/counter': typeof AdminCounterRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/daybook': typeof AdminDaybookRoute
  '/admin/kitchen': typeof AdminKitchenRoute
  '/admin/ledger': typeof AdminLedgerRoute
  '/admin/menu': typeof AdminMenuRoute
  '/admin/purchase-invoices': typeof AdminPurchaseInvoicesRoute
  '/admin/purchase-returns': typeof AdminPurchaseReturnsRoute
  '/admin/quotations': typeof AdminQuotationsRoute
  '/admin/reports': typeof AdminReportsRoute
  '/admin/sales-entry': typeof AdminSalesEntryRoute
  '/admin/sales-returns': typeof AdminSalesReturnsRoute
  '/admin/server': typeof AdminServerRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/staff': typeof AdminStaffRoute
  '/admin/tables': typeof AdminTablesRoute
  '/admin/trial-balance': typeof AdminTrialBalanceRoute
  '/admin/vouchers': typeof AdminVouchersRoute
  '/admin/': typeof AdminIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/kitchen'
    | '/login'
    | '/admin/accounts'
    | '/admin/company'
    | '/admin/counter'
    | '/admin/dashboard'
    | '/admin/daybook'
    | '/admin/kitchen'
    | '/admin/ledger'
    | '/admin/menu'
    | '/admin/purchase-invoices'
    | '/admin/purchase-returns'
    | '/admin/quotations'
    | '/admin/reports'
    | '/admin/sales-entry'
    | '/admin/sales-returns'
    | '/admin/server'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/tables'
    | '/admin/trial-balance'
    | '/admin/vouchers'
    | '/admin/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/kitchen'
    | '/login'
    | '/admin/accounts'
    | '/admin/company'
    | '/admin/counter'
    | '/admin/dashboard'
    | '/admin/daybook'
    | '/admin/kitchen'
    | '/admin/ledger'
    | '/admin/menu'
    | '/admin/purchase-invoices'
    | '/admin/purchase-returns'
    | '/admin/quotations'
    | '/admin/reports'
    | '/admin/sales-entry'
    | '/admin/sales-returns'
    | '/admin/server'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/tables'
    | '/admin/trial-balance'
    | '/admin/vouchers'
    | '/admin'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/kitchen'
    | '/login'
    | '/admin/accounts'
    | '/admin/company'
    | '/admin/counter'
    | '/admin/dashboard'
    | '/admin/daybook'
    | '/admin/kitchen'
    | '/admin/ledger'
    | '/admin/menu'
    | '/admin/purchase-invoices'
    | '/admin/purchase-returns'
    | '/admin/quotations'
    | '/admin/reports'
    | '/admin/sales-entry'
    | '/admin/sales-returns'
    | '/admin/server'
    | '/admin/settings'
    | '/admin/staff'
    | '/admin/tables'
    | '/admin/trial-balance'
    | '/admin/vouchers'
    | '/admin/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  KitchenRoute: typeof KitchenRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kitchen': {
      id: '/kitchen'
      path: '/kitchen'
      fullPath: '/kitchen'
      preLoaderRoute: typeof KitchenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/vouchers': {
      id: '/admin/vouchers'
      path: '/vouchers'
      fullPath: '/admin/vouchers'
      preLoaderRoute: typeof AdminVouchersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/trial-balance': {
      id: '/admin/trial-balance'
      path: '/trial-balance'
      fullPath: '/admin/trial-balance'
      preLoaderRoute: typeof AdminTrialBalanceRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/tables': {
      id: '/admin/tables'
      path: '/tables'
      fullPath: '/admin/tables'
      preLoaderRoute: typeof AdminTablesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/staff': {
      id: '/admin/staff'
      path: '/staff'
      fullPath: '/admin/staff'
      preLoaderRoute: typeof AdminStaffRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/server': {
      id: '/admin/server'
      path: '/server'
      fullPath: '/admin/server'
      preLoaderRoute: typeof AdminServerRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sales-returns': {
      id: '/admin/sales-returns'
      path: '/sales-returns'
      fullPath: '/admin/sales-returns'
      preLoaderRoute: typeof AdminSalesReturnsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sales-entry': {
      id: '/admin/sales-entry'
      path: '/sales-entry'
      fullPath: '/admin/sales-entry'
      preLoaderRoute: typeof AdminSalesEntryRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reports': {
      id: '/admin/reports'
      path: '/reports'
      fullPath: '/admin/reports'
      preLoaderRoute: typeof AdminReportsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/quotations': {
      id: '/admin/quotations'
      path: '/quotations'
      fullPath: '/admin/quotations'
      preLoaderRoute: typeof AdminQuotationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/purchase-returns': {
      id: '/admin/purchase-returns'
      path: '/purchase-returns'
      fullPath: '/admin/purchase-returns'
      preLoaderRoute: typeof AdminPurchaseReturnsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/purchase-invoices': {
      id: '/admin/purchase-invoices'
      path: '/purchase-invoices'
      fullPath: '/admin/purchase-invoices'
      preLoaderRoute: typeof AdminPurchaseInvoicesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/menu': {
      id: '/admin/menu'
      path: '/menu'
      fullPath: '/admin/menu'
      preLoaderRoute: typeof AdminMenuRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/ledger': {
      id: '/admin/ledger'
      path: '/ledger'
      fullPath: '/admin/ledger'
      preLoaderRoute: typeof AdminLedgerRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/kitchen': {
      id: '/admin/kitchen'
      path: '/kitchen'
      fullPath: '/admin/kitchen'
      preLoaderRoute: typeof AdminKitchenRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/daybook': {
      id: '/admin/daybook'
      path: '/daybook'
      fullPath: '/admin/daybook'
      preLoaderRoute: typeof AdminDaybookRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/counter': {
      id: '/admin/counter'
      path: '/counter'
      fullPath: '/admin/counter'
      preLoaderRoute: typeof AdminCounterRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/company': {
      id: '/admin/company'
      path: '/company'
      fullPath: '/admin/company'
      preLoaderRoute: typeof AdminCompanyRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/accounts': {
      id: '/admin/accounts'
      path: '/accounts'
      fullPath: '/admin/accounts'
      preLoaderRoute: typeof AdminAccountsRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAccountsRoute: typeof AdminAccountsRoute
  AdminCompanyRoute: typeof AdminCompanyRoute
  AdminCounterRoute: typeof AdminCounterRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminDaybookRoute: typeof AdminDaybookRoute
  AdminKitchenRoute: typeof AdminKitchenRoute
  AdminLedgerRoute: typeof AdminLedgerRoute
  AdminMenuRoute: typeof AdminMenuRoute
  AdminPurchaseInvoicesRoute: typeof AdminPurchaseInvoicesRoute
  AdminPurchaseReturnsRoute: typeof AdminPurchaseReturnsRoute
  AdminQuotationsRoute: typeof AdminQuotationsRoute
  AdminReportsRoute: typeof AdminReportsRoute
  AdminSalesEntryRoute: typeof AdminSalesEntryRoute
  AdminSalesReturnsRoute: typeof AdminSalesReturnsRoute
  AdminServerRoute: typeof AdminServerRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStaffRoute: typeof AdminStaffRoute
  AdminTablesRoute: typeof AdminTablesRoute
  AdminTrialBalanceRoute: typeof AdminTrialBalanceRoute
  AdminVouchersRoute: typeof AdminVouchersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAccountsRoute: AdminAccountsRoute,
  AdminCompanyRoute: AdminCompanyRoute,
  AdminCounterRoute: AdminCounterRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminDaybookRoute: AdminDaybookRoute,
  AdminKitchenRoute: AdminKitchenRoute,
  AdminLedgerRoute: AdminLedgerRoute,
  AdminMenuRoute: AdminMenuRoute,
  AdminPurchaseInvoicesRoute: AdminPurchaseInvoicesRoute,
  AdminPurchaseReturnsRoute: AdminPurchaseReturnsRoute,
  AdminQuotationsRoute: AdminQuotationsRoute,
  AdminReportsRoute: AdminReportsRoute,
  AdminSalesEntryRoute: AdminSalesEntryRoute,
  AdminSalesReturnsRoute: AdminSalesReturnsRoute,
  AdminServerRoute: AdminServerRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStaffRoute: AdminStaffRoute,
  AdminTablesRoute: AdminTablesRoute,
  AdminTrialBalanceRoute: AdminTrialBalanceRoute,
  AdminVouchersRoute: AdminVouchersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  KitchenRoute: KitchenRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
